// Localização: frontend/src/pages/Auth/ForgotPasswordPage.jsx
// Descrição: Página para solicitar recuperação de senha

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../api/api';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            // Validação básica de email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setError('Por favor, insira um email válido.');
                setLoading(false);
                return;
            }

            await forgotPassword(email);
            setSuccess(true);
            
            // Limpar mensagem após 5 segundos e redirecionar para login
            setTimeout(() => {
                navigate('/login');
            }, 5000);
        } catch (err) {
            const errorMessage = err.response?.data?.message || 
                               err.response?.data?.error || 
                               'Erro ao solicitar recuperação de senha. Tente novamente.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-fundo-cinza-moderno">
            <div className="w-full max-w-md p-10 space-y-8 bg-white rounded-2xl shadow-soft animate-[fadeIn_0.5s_ease-out_forwards]">
                
                {/* Cabeçalho */}
                <div className="text-center space-y-4">
                    <div className="flex justify-center">
                        <img 
                            src="/images/higeia-icon-only.png"
                            alt="Higeia.tech Logo"
                            className="h-16 w-16 object-contain transition-transform duration-300 hover:scale-110"
                        />
                    </div>
                    <div className="space-y-2">
                        <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">
                            Recuperar Senha
                        </h2>
                        <p className="text-sm text-gray-500 font-medium">
                            Digite seu email para receber um link de recuperação
                        </p>
                    </div>
                </div>

                {/* Formulário */}
                {!success ? (
                    <form className="mt-8 space-y-5" onSubmit={handleSubmit}>
                        
                        {error && (
                            <div 
                                className="p-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg transition-all duration-300 ease-out animate-[slideInFromTop_0.3s_ease-out]" 
                                role="alert"
                            >
                                {error}
                            </div>
                        )}

                        <div className="space-y-1">
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                required
                                className="appearance-none rounded-lg relative block w-full px-4 py-3 border border-gray-200 placeholder-gray-400 text-gray-900 
                                           bg-white transition-all duration-300 ease-in-out
                                           focus:outline-none focus:border-gray-400 focus:ring-1 focus:ring-gray-300
                                           hover:border-gray-300"
                                placeholder="seu@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={loading}
                            />
                        </div>

                        <button
                            type="submit"
                            className={`w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg 
                                      text-sm font-semibold text-white transition-all duration-300 ease-in-out
                                      ${loading 
                                        ? 'bg-gray-400 cursor-not-allowed' 
                                        : 'bg-higeia-medium hover:bg-higeia-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 shadow-sm hover:shadow-md transform hover:-translate-y-0.5'
                                      }`}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="flex items-center">
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Enviando...
                                </span>
                            ) : (
                                'Enviar Link de Recuperação'
                            )}
                        </button>
                    </form>
                ) : (
                    <div className="mt-8 space-y-5">
                        <div 
                            className="p-4 text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg" 
                            role="alert"
                        >
                            <p className="font-semibold mb-2">Email enviado com sucesso!</p>
                            <p>
                                Se o email estiver cadastrado, você receberá um link de recuperação de senha.
                                Verifique sua caixa de entrada e a pasta de spam.
                            </p>
                            <p className="mt-2 text-xs text-green-600">
                                Você será redirecionado para a página de login em alguns segundos...
                            </p>
                        </div>
                    </div>
                )}

                {/* Rodapé */}
                <div className="text-center text-sm pt-4 border-t border-gray-100">
                    <Link 
                        to="/login" 
                        className="font-semibold text-higeia-medium hover:text-higeia-dark transition-colors duration-200 underline-offset-2 hover:underline"
                    >
                        ← Voltar para o login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;

